"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _createClass = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingList = exports.SizeList = exports.IconList = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var icons = __importStar(require("./assets"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("@emotion/react");

var IconList = /*#__PURE__*/_createClass(function IconList() {
  _classCallCheck(this, IconList);

  this["abstract-expand"] = icons.AbstractExpand;
  this["abstract-layers"] = icons.AbstractLayers;
  this["abstract-nest"] = icons.AbstractNest;
  this["abstract-parallel"] = icons.AbstractParallel;
  this["abstract-perpendicular"] = icons.AbstractPerpendicular;
  this["abstract-rotate"] = icons.AbstractRotate;
  this["abstract-spin"] = icons.AbstractSpin;
  this["account"] = icons.Account;
  this["arrow-down"] = icons.ArrowDown;
  this["arrow-up-right"] = icons.ArrowUpRight;
  this["attachment"] = icons.Attachment;
  this["backward-arrow"] = icons.BackwardArrow;
  this["bank"] = icons.Bank;
  this["barcode"] = icons.Barcode;
  this["bars"] = icons.Bars;
  this["bell-alert"] = icons.BellAlert;
  this["bookmark"] = icons.Bookmark;
  this["briefcase"] = icons.Briefcase;
  this["calendar"] = icons.Calendar;
  this["call-us"] = icons.CallUs;
  this["capabilities-drilled-bar"] = icons.CapabilitiesDrilledBar;
  this["capabilities-fabrication"] = icons.CapabilitiesFabrication;
  this["capabilities-plate-laser"] = icons.CapabilitiesPlateLaser;
  this["capabilities-sawing"] = icons.CapabilitiesSawing;
  this["capabilities-tube-laser"] = icons.CapabilitiesTubeLaser;
  this["certification"] = icons.Certification;
  this["chat"] = icons.Chat;
  this["check"] = icons.Check;
  this["check-complete"] = icons.CheckComplete;
  this["chevron-down"] = icons.ChevronDown;
  this["chevron-down-double"] = icons.ChevronDownDouble;
  this["chevron-left"] = icons.ChevronLeft;
  this["chevron-right"] = icons.ChevronRight;
  this["chevron-up"] = icons.ChevronUp;
  this["clone"] = icons.Clone;
  this["close"] = icons.Close;
  this["comment"] = icons.Comment;
  this["cut"] = icons.Cut;
  this["default"] = icons.Default;
  this["clipboard-check"] = icons.ClipboardCheck;
  this["diversity-inclusion"] = icons.DiversityInclusion;
  this["dollar-sign"] = icons.DollarSign;
  this["dot-circle"] = icons.DotCircle;
  this["edit"] = icons.Edit;
  this["envelope"] = icons.Envelope;
  this["environment"] = icons.Environment;
  this["equipment-excavator"] = icons.EquipmentExcavator;
  this["equipment-saw"] = icons.EquipmentSaw;
  this["equipment-tractor"] = icons.EquipmentTractor;
  this["ellipsis-h"] = icons.EllipsisH;
  this["error"] = icons.Error;
  this["exclamation"] = icons.Exclamation;
  this["family"] = icons.Family;
  this["file-cabinet"] = icons.FileCabinet;
  this["file-pdf"] = icons.FilePdf;
  this["file-xls"] = icons.FileXls;
  this["filter"] = icons.Filter;
  this["financial"] = icons.Financial;
  this["folder"] = icons.Folder;
  this["forward"] = icons.Forward;
  this["backward"] = icons.Backward;
  this["gear"] = icons.Gear;
  this["globe"] = icons.Globe;
  this["grid"] = icons.Grid;
  this["health"] = icons.Health;
  this["help"] = icons.Help;
  this["history"] = icons.History;
  this["home-outline"] = icons.HomeOutline;
  this["industry-auto"] = icons.IndustryAuto;
  this["industry-distribution-systems"] = icons.IndustryDistributionSystems;
  this["industry-electric-vehicles"] = icons.IndustryElectricVehicles;
  this["industry-heavy-equipment"] = icons.IndustryHeavyEquipment;
  this["industry-metal-fabrication"] = icons.IndustryMetalFabrication;
  this["industry-oil-gas"] = icons.IndustryOilGas;
  this["industry-packaging-equipment"] = icons.IndustryPackagingEquipment;
  this["industry-power-storage"] = icons.IndustryPowerStorage;
  this["industry-stamping"] = icons.IndustryStamping;
  this["industry-technology"] = icons.IndustryTechnology;
  this["industry-tool-die"] = icons.IndustryToolDie;
  this["industry-transportation"] = icons.IndustryTransportation;
  this["info"] = icons.Info;
  this["layer-group"] = icons.LayerGroup;
  this["leave"] = icons.Leave;
  this["list-bullet"] = icons.ListBullet;
  this["list-group"] = icons.ListGroup;
  this["list-help"] = icons.ListHelp;
  this["list-lines"] = icons.ListLines;
  this["location"] = icons.Location;
  this["location-arrow"] = icons.LocationArrow;
  this["location-marker"] = icons.LocationMarker;
  this["location-marker-outline"] = icons.LocationMarkerOutline;
  this["login"] = icons.Login;
  this["mail"] = icons.Mail;
  this["material-angle"] = icons.MaterialAngle;
  this["material-bar"] = icons.MaterialBar;
  this["material-bar-flat"] = icons.MaterialBarFlat;
  this["material-bar-grating"] = icons.MaterialBarGrating;
  this["material-bar-half-oval"] = icons.MaterialBarHalfOval;
  this["material-bar-half-round"] = icons.MaterialBarHalfRound;
  this["material-bar-hexagon"] = icons.MaterialBarHexagon;
  this["material-bar-octagon"] = icons.MaterialBarOctagon;
  this["material-bar-reinforcing"] = icons.MaterialBarReinforcing;
  this["material-bar-round"] = icons.MaterialBarRound;
  this["material-bar-square"] = icons.MaterialBarSquare;
  this["material-bar-tee"] = icons.MaterialTee;
  this["material-beam"] = icons.MaterialBeam;
  this["material-channel"] = icons.MaterialChannel;
  this["material-coil"] = icons.MaterialCoil;
  this["material-expanded-flat"] = icons.MaterialExpandedFlat;
  this["material-expanded-standards"] = icons.MaterialExpandedStandard;
  this["material-open-grip"] = icons.MaterialOpenGrip;
  this["material-pipe"] = icons.MaterialPipe;
  this["material-plate"] = icons.MaterialPlate;
  this["material-plate-tread-diamond"] = icons.MaterialPlateTreadDiamond;
  this["material-plate-tread-medium"] = icons.MaterialPlateTreadMedium;
  this["material-rod"] = icons.MaterialRod;
  this["material-sheet"] = icons.MaterialSheet;
  this["material-sheets"] = icons.MaterialSheets;
  this["material-tee"] = icons.MaterialTee;
  this["material-threaded-rod"] = icons.MaterialThreadedRod;
  this["material-tread-coil"] = icons.MaterialTreadCoil;
  this["material-tube-rectangular"] = icons.MaterialTubeRectangular;
  this["material-tube-round"] = icons.MaterialTubeRound;
  this["material-tube-square"] = icons.MaterialTubeSquare;
  this["material-zee"] = icons.MaterialZee;
  this["message"] = icons.Message;
  this["minus"] = icons.Minus;
  this["more"] = icons.More;
  this["news"] = icons.News;
  this["pay"] = icons.Pay;
  this["payment-ach"] = icons.PaymentAch;
  this["payment-amex"] = icons.PaymentAmex;
  this["payment-discover"] = icons.PaymentDiscover;
  this["payment-echeck"] = icons.PaymentEcheck;
  this["payment-mastercard"] = icons.PaymentMastercard;
  this["payment-paypal"] = icons.PaymentPaypal;
  this["payment-visa"] = icons.PaymentVisa;
  this["payment-wire-transfer"] = icons.PaymentWireTransfer;
  this["people"] = icons.People;
  this["percent-sign"] = icons.PercentSign;
  this["person"] = icons.Person;
  this["person-outline"] = icons.PersonOutline;
  this["phone"] = icons.Phone;
  this["phone-outline"] = icons.PhoneOutline;
  this["pin-check"] = icons.PinCheck;
  this["play"] = icons.Play;
  this["plus"] = icons.Plus;
  this["print"] = icons.Print;
  this["products"] = icons.Products;
  this["product-quality"] = icons.ProductQuality;
  this["question-mark"] = icons.QuestionMark;
  this["quote"] = icons.Quote;
  this["revert"] = icons.Revert;
  this["ryerson-gives-back"] = icons.RyersonGivesBack;
  this["secure"] = icons.Secure;
  this["scan"] = icons.Scan;
  this["search"] = icons.Search;
  this["service-blanchard-grinding"] = icons.ServiceBlanchardGrinding;
  this["share"] = icons.Share;
  this["shopping-cart"] = icons.ShoppingCart;
  this["shopping-cart-native"] = icons.ShoppingCartNative;
  this["sign-out"] = icons.SignOut;
  this["square-share"] = icons.SquareShare;
  this["social-facebook"] = icons.SocialFacebook;
  this["social-instagram"] = icons.SocialInstagram;
  this["social-linked-in"] = icons.SocialLinkedIn;
  this["social-youtube"] = icons.SocialYoutube;
  this["solution-advanced-processing"] = icons.SolutionAdvancedProcessing;
  this["solution-bar-tube-structural-processing"] = icons.SolutionBarTubeStructuralProcessing;
  this["solution-carbon-sheet-solutions"] = icons.SolutionCarbonSheetSolutions;
  this["solution-custom-aluminum-extrusions"] = icons.SolutionCustomAluminumExtrusions;
  this["solution-fabrication"] = icons.SolutionFabrication;
  this["solution-global-accounts"] = icons.SolutionGlobalAccounts;
  this["solution-plate-processing"] = icons.SolutionPlateProcessing;
  this["solution-sheet-coil-processing"] = icons.SolutionSheetCoilProcessing;
  this["solution-truckload-quantities"] = icons.SolutionTruckloadQuantities;
  this["star"] = icons.Star;
  this["success"] = icons.Success;
  this["swap"] = icons.Swap;
  this["tachometer-slow"] = icons.TachometerSlow;
  this["text-a"] = icons.TextA;
  this["text-b"] = icons.TextB;
  this["text-d"] = icons.TextD;
  this["text-h"] = icons.TextH;
  this["text-n"] = icons.TextN;
  this["text-id"] = icons.TextID;
  this["text-l"] = icons.TextL;
  this["text-od"] = icons.TextOD;
  this["text-s"] = icons.TextS;
  this["text-t"] = icons.TextT;
  this["text-w"] = icons.TextW;
  this["timer"] = icons.Timer;
  this["the-gauge"] = icons.TheGauge;
  this["trash"] = icons.Trash;
  this["view"] = icons.View;
  this["warning"] = icons.Warning;
  this["why-metal-matters"] = icons.WhyMetalMatters;
  this["write"] = icons.Write;
  this["no-view"] = icons.NoView;
});

exports.IconList = IconList;

var SizeList = /*#__PURE__*/_createClass(function SizeList() {
  _classCallCheck(this, SizeList);

  this["xs"] = "12";
  this["sm"] = "18";
  this["sm-md"] = "20"; // Deprecated

  this["md"] = "24";
  this["lg"] = "30";
  this["xl"] = "40";
  this["fit"] = "fit";
});

exports.SizeList = SizeList;

var PaddingList = /*#__PURE__*/_createClass(function PaddingList() {
  _classCallCheck(this, PaddingList);

  this["xs"] = "2";
  this["sm"] = "3";
  this["sm-md"] = "4";
  this["md"] = "5";
  this["lg"] = "6";
  this["xl"] = "8";
  this["fit"] = "0";
});

exports.PaddingList = PaddingList;

var Icon = function Icon(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      color = _ref.color,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      disabledColor = _ref.disabledColor,
      hoverColor = _ref.hoverColor,
      onClick = _ref.onClick,
      _ref$circled = _ref.circled,
      circled = _ref$circled === void 0 ? false : _ref$circled,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$isNative = _ref.isNative,
      isNative = _ref$isNative === void 0 ? false : _ref$isNative;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  if (!color) {
    color = isNative ? theme.colors.primary.gray : theme.colors.primary.darkGray;
  }

  if (!disabledColor) {
    disabledColor = theme.colors.primary.lightGray;
  }

  var SelectedIcon = new IconList()[icon];
  var iconSize = new SizeList()[size];
  var paddingSize = new PaddingList()[size];
  var iconColor = disabled ? disabledColor : color;
  var circleColor = selected && !disabled ? theme.colors.primary.primaryBrand : iconColor;
  var cursor = disabled ? "inherit" : onClick ? "pointer" : "default";

  var onIconClick = function onIconClick(event) {
    if (onClick) {
      event.stopPropagation();
      onClick(event);
    }
  };

  var circleStyle = (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tborder-radius: 50%;\n\t\tborder: 1px solid ", ";\n\t\tpadding: ", "px;\n\t\t", "\n\t"])), circleColor, paddingSize, !disabled && hoverColor && "\n      :hover {\n        border: 1px solid ".concat(hoverColor, ";\n      }\n    "));
  var IconWrapper = styled_1.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\theight: ", ";\n\t\twidth: ", ";\n\t\tcolor: ", ";\n\t\tcursor: ", ";\n\t\tbox-sizing: border-box;\n\t\t", ";\n\t\tdisplay: inline-flex;\n\t\tjustify-content: center;\n\t\t", "\n\t"])), iconSize === "fit" ? "100%" : iconSize + "px", iconSize === "fit" ? "100%" : iconSize + "px", iconColor, cursor, circled && circleStyle, !disabled && hoverColor && "\n      :hover {\n        color: ".concat(hoverColor, ";\n      }\n    "));
  return (0, jsx_runtime_1.jsx)(IconWrapper, {
    className: className,
    "data-testid": dataTestId,
    onClick: !disabled ? onIconClick : undefined,
    children: (0, jsx_runtime_1.jsx)(SelectedIcon, {})
  });
};

exports.default = Icon;